import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    url: String,
    action: String,
    proxyName: String
  };

  toggle(event) {
    event.preventDefault();

    if (this.actionValue === 'disable') {
      this.promptForReason();
    } else {
      this.enable();
    }
  }

  promptForReason() {
    const reason = prompt(
      `Disable ${this.proxyNameValue} for this bank?\n\nPlease enter a reason (max 20 chars):`,
      ''
    );

    if (reason !== null) {
      if (reason.trim() === '') {
        alert('Please provide a reason for disabling.');
        return;
      }
      if (reason.length > 20) {
        alert('Reason must be 20 characters or less.');
        return;
      }
      this.disable(reason);
    }
  }

  disable(reason) {
    this.submitForm('disable', reason);
  }

  enable() {
    if (confirm(`Enable ${this.proxyNameValue} for this bank?`)) {
      this.submitForm('enable');
    }
  }

  submitForm(action, reason = null) {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = this.urlValue;

    // Rails CSRF token
    const csrfToken = document.querySelector('[name="csrf-token"]').content;
    const csrfInput = document.createElement('input');
    csrfInput.type = 'hidden';
    csrfInput.name = 'authenticity_token';
    csrfInput.value = csrfToken;
    form.appendChild(csrfInput);

    // Method override for PATCH
    const methodInput = document.createElement('input');
    methodInput.type = 'hidden';
    methodInput.name = '_method';
    methodInput.value = 'patch';
    form.appendChild(methodInput);

    // Add reason if disabling
    if (reason) {
      const reasonInput = document.createElement('input');
      reasonInput.type = 'hidden';
      reasonInput.name = 'disabled_reason';
      reasonInput.value = reason;
      form.appendChild(reasonInput);
    }

    document.body.appendChild(form);
    form.submit();
  }
}
